import type { FaireProductEntity } from "../../entity_types/product";

export const p_rs8jx57yku: FaireProductEntity = {
  token: "p_rs8jx57yku",
  type: "product",
  name: "Arkansas Razorbacks Logo Bandana Scarf Necklace",
  brandToken: "b_emgllltle6",
  brandName: "Canvas Style",
  imageUrl:
    "https://cdn.faire.com/fastly/17e8e8fda1b2a61349585cf820e4e469f3608909cbf6896f09d94c5c6a2379d5.png",
  galleryImageUrls: [],
  priceDollars: 16.5,
  description:
    "Wooo Pig Sooie never looked so stylish. This preppy scarf necklace adds flair to your Razorbacks spirit.\n\n",
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:24:24.080Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
